/**
 * Formats a string number into a percentage string with "," as decimals separator.
 *
 * @param {String} value the value to format
 * @returns the percentage string value
 */
export const formatPercentage = value => (value || value === 0 ? `${value.toString().replace(".", ",")}%` : "");
/**
 * Formats a string number into a percentage string.
 *
 * @param {String} value the value to format
 * @returns the percentage string value
 */
export const formatSimplePercentage = value =>
    value ? `${value}${value.includes("-") || value.includes(">") || value.includes("<") ? " " : ""}%` : "-";

/**
 * Hashes a given string after transforming to lower case.
 *
 * @param {String} plainStr the string to hash
 * @returns the hashed string
 */
export function hashLowerCaseString(plainStr) {
    let hash = 0;

    if (!plainStr || plainStr.length === 0) {
        return hash;
    }

    const plainStrLowerCase = plainStr.toLowerCase();

    for (let i = 0; i < plainStrLowerCase.length; i++) {
        let char = plainStrLowerCase.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash = hash & hash;
    }

    return Math.abs(hash);
}

/**
 * Converts a boolean string to a boolean value.
 *
 * @param {String} str the boolean value as a string
 * @returns the boolean value
 */
export const convertToBoolean = str => (str === "true" ? true : false);

/**
 * Converts an array string to an array value.
 *
 * @param {String} str the array value as a string
 * @returns the array value
 */
export const convertToArray = str => (str ? str.split(",") : []);

/**
 * Counts the words ina string.
 *
 * @param {String} str the array value as a string
 * @returns the array value
 */

export const countWordsInStr = str => {
    let wordCounts = {};

    for (var key in str) {
        // eslint-disable-next-line no-prototype-builtins
        if (str.hasOwnProperty(key)) {
            var sequence = str[key];
            var words = sequence.split(/\s+/);
            var wordCount = words.length;

            wordCounts[key] = wordCount;
        }
    }
    return wordCounts;
};
